import get from 'lodash/get';
/**
 * reads auto suggest TTL from app config
 */
export const getAutoSuggestTTL = (config) => {
    return get(config, ['data', 'globalConfig', 'autoSuggestCacheTTLInMillis'], 0);
};
/**
 * Checks if we have auto suggest data for a given query and marketplace
 * and if the data is within a specified TTL (specified in app config)
 * @param autoSuggestEntries auto suggest data from cache
 * @param query query text entered by user
 * @param marketPlaceId represents marketplace, FLIPKART or GROCERY
 * @param autoSuggestTTL auto suggest TTL (time in millis for which a fetched suggestion is valid)
 */
export const shouldFetchEntries = (autoSuggestEntries, query, marketPlaceId, autoSuggestTTL) => {
    const autoSuggestWords = autoSuggestEntries && autoSuggestEntries.words;
    if (!autoSuggestWords) {
        return true;
    }
    const searchHistoryKey = `${query} - ${marketPlaceId}`;
    const searchResults = autoSuggestWords[searchHistoryKey];
    const firstSearchResult = searchResults && searchResults[0];
    if (!firstSearchResult) {
        return true;
    }
    // `userTimeStamp`s for a search query in `searchResults` are all same.
    // comparing with just the first suggestion.
    return Date.now() - firstSearchResult.userTimeStamp > autoSuggestTTL;
};
